
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export type CTAVariant = "blue" | "orange" | "yellow" | "purple" | "green";

interface PageCTAProps {
  title: string;
  description?: string;
  buttonText: string;
  variant?: CTAVariant;
  className?: string;
  onClick?: () => void;
}

const PageCTA: React.FC<PageCTAProps> = ({
  title,
  description,
  buttonText,
  variant = "blue",
  className = "",
  onClick
}) => {
  const getBgClass = () => {
    switch (variant) {
      case "orange":
        return "bg-orange-gradient";
      case "yellow":
        return "bg-amber-50 border border-amber-100";
      case "purple":
        return "bg-gradient-to-r from-purple-600 to-indigo-600 text-white";
      case "green":
        return "bg-gradient-to-r from-emerald-500 to-teal-500 text-white";
      case "blue":
      default:
        return "bg-gradient-to-r from-blue-600 to-blue-800 text-white";
    }
  };

  const getButtonClass = () => {
    switch (variant) {
      case "orange":
        return "bg-assembly-orange hover:bg-orange-700 text-white";
      case "yellow":
        return "bg-assembly-orange hover:bg-orange-700 text-white";
      case "purple":
        return "bg-white text-purple-700 hover:bg-gray-100";
      case "green":
        return "bg-white text-teal-700 hover:bg-gray-100";
      case "blue":
      default:
        return "bg-white text-blue-700 hover:bg-gray-100";
    }
  };

  return (
    <section className={`py-12 md:py-16 my-8 rounded-xl ${getBgClass()} ${className}`}>
      <div className="max-w-4xl mx-auto text-center px-4">
        <h2 className={`text-3xl font-bold ${variant === "blue" || variant === "purple" || variant === "green" ? "text-white" : "text-gray-900"} mb-4`}>
          {title}
        </h2>
        {description && (
          <p className={`mt-4 text-xl ${variant === "blue" || variant === "purple" || variant === "green" ? "text-white/90" : "text-gray-700"} mb-8`}>
            {description}
          </p>
        )}
        <Button 
          onClick={onClick}
          className={`${getButtonClass()} px-10 py-6 rounded-md text-xl font-medium shadow-lg transform transition-all hover:scale-105 flex items-center gap-2 mx-auto`}
        >
          {buttonText}
          <ArrowRight className="h-5 w-5" />
        </Button>
      </div>
    </section>
  );
};

export default PageCTA;
